import * as THREE from 'three';

const {OrbitControls} = require("three/examples/jsm/controls/OrbitControls");

class EyeBall extends THREE.Mesh {
	constructor() {
		let g = new THREE.SphereGeometry(1, 64, 32).rotateX(Math.PI * 0.5);
		let m = new THREE.MeshLambertMaterial({
			onBeforeCompile: shader => {
				shader.vertexShader = `
          varying vec3 vPos;
          ${shader.vertexShader}
        `.replace(
					`#include <begin_vertex>`,
					`#include <begin_vertex>
            vPos = position;
          `
				);

				shader.fragmentShader = `
          varying vec3 vPos;
          ${shader.fragmentShader}
        `.replace(
					`vec4 diffuseColor = vec4( diffuse, opacity );`,
					`vec4 diffuseColor = vec4( diffuse, opacity );

            vec3 dir = vec3(0, 0, 1);

            vec3 nPos = normalize(vPos);

            float dotProduct = dot(dir, nPos);

            float iris = smoothstep(0.75, 0.8, dotProduct);
            diffuseColor.rgb = mix(diffuseColor.rgb, vec3(52.0/255.0, 137.0/255.0, 146.0/255.0), iris);

            float pupil = smoothstep(0.95, 0.97, dotProduct);
            diffuseColor.rgb = mix(diffuseColor.rgb, vec3(0), pupil);
          `
				);
			}
		});
		super(g, m);
	}
}

class Eyes extends THREE.Group {
	constructor(camera, mouse) {
		super();
		this.camera = camera;

		this.plane = new THREE.Plane();
		this.planeNormal = new THREE.Vector3();
		this.planePoint = new THREE.Vector3();

		this.pointer = new THREE.Vector2();
		this.raycaster = new THREE.Raycaster();

		this.lookAt = new THREE.Vector3();

		this.eyes = new Array(2).fill().map((_, idx) => {
			let eye = new EyeBall();
			eye.position.x = 1.1 * (idx < 1 ? -1 : 1);
			this.add(eye);
			return eye;
		})

		document.addEventListener("pointermove", event => {
			this.pointer.x = ((event.clientX / window.innerWidth) * 2 - 1) * 4;
			this.pointer.y = (-(event.clientY / window.innerHeight) * 2 + 1) * 4;
		})
	}

	update() {
		this.raycaster.setFromCamera(this.pointer, this.camera);

		this.camera.getWorldDirection(this.planeNormal);
		this.planePoint.copy(this.planeNormal).setLength(5).add(this.camera.position);
		this.plane.setFromNormalAndCoplanarPoint(this.planeNormal, this.planePoint);

		this.raycaster.ray.intersectPlane(this.plane, this.lookAt);

		this.eyes.forEach(eye => {
			eye.lookAt(this.lookAt)
		});
	}
}

const InitEye = () => {
	const eye = document.querySelector('#eye-area');
	if (!eye) return;

	let scene = new THREE.Scene();
	let camera = new THREE.PerspectiveCamera(20, eye.clientWidth / eye.clientHeight, 1, 1000);
	camera.position.set(0, 0, 10).setLength(10);
	let renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
	renderer.setSize(eye.clientWidth, eye.clientHeight);
	eye.appendChild(renderer.domElement);
	window.addEventListener("resize", event => {
		camera.aspect = eye.clientWidth / eye.clientHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(eye.clientWidth, eye.clientHeight);
	})

	let controls = new OrbitControls(camera, renderer.domElement);
	controls.enableDamping = true;
	controls.enableZoom = false;

	let light = new THREE.DirectionalLight(0xffffff, Math.PI);
	light.position.setScalar(1);
	scene.add(light, new THREE.AmbientLight(0xffffff, Math.PI * 0.5));

// scene.add(new THREE.GridHelper());

	let eyes = new Eyes(camera);
	scene.add(eyes);

	let clock = new THREE.Clock();
	let t = 0;

	renderer.setAnimationLoop(() => {
		let dt = clock.getDelta();
		t += dt;
		controls.update();

		// eyes.position.y = Math.abs(Math.sin(t) * 2) + 1;
		eyes.update();

		renderer.render(scene, camera);
	})
}

InitEye()
